export const colors: any = {
  primary: '#0C70BC',
  primary50: '#1B9742',
  primaryLight: '#E6EDF7',
  secondary: '#E11D48',
  danger: '#ED4337',
  white: '#ffffff',
  black: '#000',
  inputBorder: '#C8CDE0',
  brown50: '#E8E8E8',
  text: '#343F52',
  text50: '#A0A0A0',
  textGrey: '#4B5563',
  grey500: '#333333',
  placeholder: '#B9B9B9',
  borderColor: '#e9e9e9',
  childrenColor: '#fdfdfd',
  shadowColor: '#eff3f9',
  red: '#FE1B1B',
  red500: '#FD2100',
  red50: '#FFE9E6',
  success100: '#22C55E',
  success50: '#E9FFF1',
  yellow500: '#E2AF2C',
  yellow100: '#FEF0CD',
  boxShadow: `0 0 8px 0px #E6EDF7`,
  reject: '#E72929',
  accept: '#4CAF50',
  darkBlue: '#E9EAEF',
  foundationGrey500: '#1E1E1E',
  grey50: '#686868',
  secondaryText: '#88888C',
  lightBlue50: '#E9F1F8',
  messageInputBg: '#F5F5F599',
  text100: '#4A4A4A',
  text200: '#757575',
  //statuses
  fullyPaidBg: '#d9ffd9',
  fullyPaidText: '#2c8000',
}

export const createTheme = () => {
  const theme = {
    colors: colors,
  }

  return theme
}

const theme = createTheme()
export default theme
